<template>
  <div
    v-if="selectedUser"
    :class="[type === 'taskView' && _.isEmpty(task) ? 'float-right' : 'float-left']"
    class="btn-group-toggle dropdown">
    <div
      data-toggle="dropdown"
      :class="{'p-2': type === 'taskView', dropdownContainerTaskView: type === 'taskView' && _.isEmpty(task)}"
      class="dropdownContainer">
      <img
        v-if="selectedUser.picture_url"
        :src="selectedUser.picture_url"
        :style="{width: _.isEmpty(task) ? '29px' : '19px', height: _.isEmpty(task) ? '29px' : '19px'}"
        style="transition: 1s filter ease-out; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);"
        alt="..."
        class="avatar-img rounded-circle shadow-sm mr-2 float-left">
      <span
        v-else
        :style="{width: _.isEmpty(task) ? '29px' : '19px', height: _.isEmpty(task) ? '29px' : '19px'}"
        class="avatar-title rounded-circle mr-2 float-left"
        style="background-color: #9baac1; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);">
          {{(selectedUser.first_name || '').slice(0, 1)+(selectedUser.last_name || '').slice(0, 1)}}
      </span>
      <div
        v-if="type === 'taskView'"
        class=" assignee ml-1"
        style="cursor: pointer; ">
        <h5 v-if="_.isEmpty(task)" class="mb-1 text-muted small">{{ $t('common.edit_task.assignee') }}</h5>
        <h5 v-if="_.isEmpty(task)" class="mb-0" style="font-weight: normal" v-html="taskViewName"></h5>
        <h6 v-else class="mb-0" style="font-weight: normal" v-html="taskViewName"></h6>
      </div>
      <span
        v-if="type === 'header'"
        class="personContainer ml-1">
        {{selectedUser.first_name}}
        {{selectedUser.last_name}}
      </span>

      <router-link v-if="type === 'header'"  :to="'/insights/members/'+selectedUser._id" class="subRouter">
        Open Profile
      </router-link>
    </div>

    <div
      :class="{ 'margin-left-task-view' : type === 'taskView'}"
      class="dropdown-menu pb-0">
      <div
        class="col-11 ml-3 p-0 mb-2">
        <input
          v-model="searchString"
          class="searchProject" type="search" >
          <div
            v-if="searchString"
            @click.stop="searchString = ''"
            class="closeButton">
            <i class="fe fe-x"></i>
          </div>
      </div>
      <span
        @click="selectUser(member._id)"
        v-for="member of focusedItems"
        v-bind:key="member._id"
        type="button"
        class="dropdown-item pr-0 pl-0">
        <popover-member-item :member="member"></popover-member-item>
      </span>
      <router-link class="dropdown-item pr-0 pl-0" style="color:#35A666;" to="/insights/invites_management">
        <div class="row pl-3 pr-1">
          <div class="col-md-1 d-flex justify-content-center pr-0">
            <div
              class="avatar-disabled"
              style="width: 16px !important; height: 16px !important; margin-top: -2px">
              <div style="width: 16px !important; height: 16px !important;" class="avatar avatar ml-1">
                <span
                  class="avatar-title rounded-circle"
                  style="font-size: .4em; background-color: inherit;  border: 0.8px dashed #35A666; border-radius: 50%">
              <i class="fe fe-user-plus" style="color: #35A666"></i>
          </span>
              </div>
            </div>
          </div>
          <div class="col-md-11 pl-3 pr-4">
            <span>Invite Members</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PopoverMemberItem from '../../elements/PopoverMemberItem';
  export default {
    name: 'NewPersonSelect',
    computed: {
      ...mapGetters([
        'projects',
        'members',
        'selected_account_id',
        'selected_task',
      ]),
      taskViewName: function () {
        return this.selectedUser.last_name.length + this.selectedUser.first_name.length + 1 > 16 ? `<b>${this.selectedUser.first_name}</b> ${this.selectedUser.last_name.substr(0, 13 - this.selectedUser.first_name.length)}...`
          : `<b>${this.selectedUser.first_name}</b> ${this.selectedUser.last_name}`;
      },
      selectedUser: function () {
        let localMember = {};

        if (this._.isEmpty(this.task) && this.members) {
          localMember = this.members.filter(member => {
            return this.type === 'header' ? member._id === this.selected_account_id : member._id === this.selected_task.assignee;
          })[0];
        } else {
          localMember = this.members.filter(member => {
            return member._id === this.task.assignee;
          })[0];
        }

        if (this._.isEmpty(localMember) && this.type === 'taskView') {
          this.assignEmikaAssignee();
          localMember = this.members.filter(member => {
            return member._id === 'emika';
          })[0];
        }

        return localMember;
      },
      selectedProject: function () {
        return this.projects.filter(project => {
          return this._.isEmpty(this.task) ? project._id === this.selected_task.project_id : project._id === this.task.project_id;
        })[0];
      },
      focusedItems: function () {
        switch (this.type) {
        case 'header':
          return this.members.filter(member => {
            return member._id !== 'emika' && `${member.first_name} ${member.last_name}`.toLowerCase().includes(this.searchString.toLowerCase());
          });
        case 'taskView':
          return this.members.filter(member => {
            if (this.selectedProject) {
              return (member._id === 'emika') || (this.selectedProject.members.indexOf(member._id) >= 0 && `${member.first_name} ${member.last_name}`.toLowerCase().includes(this.searchString.toLowerCase()));
            } else {
              return (member._id === 'emika');
            }
          });
        default:
          return [];
        }
      },
    },
    props: {
      type: {
        default: 'header',
      },
      task: {
        default: function () {
          return {};
        },
      },
    },
    data () {
      return {
        searchString: '',
      };
    },
    components: {
      PopoverMemberItem,
    },
    methods: {
      selectUser (newId) {
        if (this._.isEmpty(this.task)) {
          // this.$store.commit('setTaskFilter', {slug: 'by_text', value: ''});
          this.$store.commit('setTaskFilter', { slug: 'by_assignees', value: [newId] });
          // this.$store.commit('setTaskFilter', {slug: 'by_creators', value: []});
          // this.$store.commit('setTaskFilter', {slug: 'by_user', value: 'all_people'});
          // this.$store.commit('setTaskFilter', {slug: 'by_priority', value: 'all'});
          this.$store.commit('setTaskFilter', { slug: 'by_status', value: 'incomplete' });
          this.$store.commit('setTaskFilter', { slug: 'by_plan_date', value: 'unplanned' });
          // this.$store.commit('setTaskFilter', {slug: 'by_deadline_date', value: 'all'});
          if (this.type === 'header') {
            this.$store.commit('setSelectedAccountId', newId);
            localStorage.setItem('selectedAccountId', newId);
          } else {
            this.selected_task.assignee = newId;
          }
        } else {
          this.task.assignee = newId;
          const task = Object.assign(this.task, { token: localStorage.getItem('token') });
          this.$socket.emit('server_update_task', task);
        }
      },
      assignEmikaAssignee () {
        if (this.selected_task) {
          this.selected_task.assignee = 'emika';
        }
      },
    },
  };
</script>

<style scoped>
  ::-webkit-scrollbar {
    display: none;
  }
  .activeItem {
    color: #35A666 !important;
  }

  .searchProject {
    transition-duration: .2s;
    width: 100%;
    vertical-align: middle;
    padding-left: 5px;
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid rgba(225, 236, 251, 0.8);
    border-radius: 0.375rem;
  }

  .searchProject:focus {
    transition-duration: .2s;
    border: 1px solid #35A666;
  }
    .closeButton {
      position: absolute;
      top: 0;
      left: 92%;
      cursor: pointer;
      color: #96ABC8;
    }

  .personContainer{
    cursor: pointer;
    width: 304px;
    padding: 2.5px;
    margin-top: 2px;
    display: inline-block;
    background: #FFFFFF;
    border: 1px solid #E6EDF9;
    border-radius: 4px;
    font-size: 12px;
  }

  .dropdown-menu {
    overflow-y: auto;
    overflow-x: hidden;
    width: 304px !important;
    max-height: 230px;
    margin-left: 38px;
    margin-top: 7px;
    font-size: 16px;
  }
    .margin-left-task-view {
      margin-left: 0;
    }

    .dropdown-item:hover {
      background-color: #F0F2F5;
    }

    .dropdown-item {
      -webkit-appearance: none;
    }

  .subText{
    display: none;
    position: fixed;
    margin-left: -140px;
    margin-top: 10px;
  }
  .subRouter{
    color: rgba(150, 171, 200, 0.11);
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    font-size: 14px;
    margin-left: 10px;
    transition: color 0.3s ease-in-out;
  }

  .dropdownContainerTaskView {
    transition: background-color 0.3s ease-in-out;
  }
  .dropdownContainerTaskView:hover {
    transition: background-color 0.3s ease-in-out;
    background-color: #F8F9FC;
    border-radius: 5px;
  }

  .dropdownContainer:hover .subRouter{
    color: #96ABC8;
    transition: color 0.3s ease-in-out;
  }

  .assignee {
    position: relative;
    top: 0;
    overflow: auto;
  }

</style>
